var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaptureSelfie = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    width: "100%",
    height: "100%",
    transform: "translate3d(0,0,0)",
    contentVisibility: "visible"
  },
  viewBox: "0 0 296 296"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 24.5,
  x2: 217.5,
  y1: 30.8,
  y2: 256.8,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--thc-color-mid-grey)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--thc-color-mid-grey)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 54.3,
  x2: 54.3,
  y1: 33.7,
  y2: 91.2,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B1B1B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 12.9,
  x2: 3.5,
  y1: 18.5,
  y2: 19.5,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "17%",
  stopColor: "#BDBDBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "64%",
  stopColor: "#E1E1E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DDD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 12.9,
  x2: 3.5,
  y1: 18.5,
  y2: 19.5,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "4%",
  stopColor: "#B5B5B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#E2E2E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 6.6,
  x2: 82.3,
  y1: 75.3,
  y2: 75.6,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M297 0v297H0V0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-color-primary-light-yellow)",
  d: "M148 272a124 124 0 1 0 0-248 124 124 0 0 0 0 248"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M25 73.5v.5c-.2 9.8-8.5 17.2-25 22.2 19.9 14.5 39.7 26 59.6 26s39.8-11.5 59.6-26c-16.4-5-24.7-12.4-24.9-22.3V30c1.2.1 1.1 0 0-.3 0-12.3.1 3.8.2-13 0-17-70.7-32-69.7 14.3l.1 42.6z",
  transform: "translate(89 130.3)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-color-dark-grey)",
  d: "M236.7 234.7a123.6 123.6 0 0 1-177 .4c21.3-8.8 42.8-14.7 42.8-14.7 6.3 11.5 24.9 21.9 43.9 22.3 20.6.5 41.7-9.9 48.2-22.3 0 0 21 5.7 42 14.3z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M3.8 2.8c4.5-6 9-1 10.6 2.3V34c-.4 2.5-2 3.9-6 3.9-4.9 0-6.9-13.7-7.5-18.7-.7-5.1-2.7-9 3-16.4z",
  transform: "translate(85 119.2)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M3.8 2.8c4.5-6 9-1 10.6 2.3V34c-.4 2.5-2 3.9-6 3.9-4.9 0-6.9-13.7-7.5-18.7-.7-5.1-2.7-9 3-16.4z",
  transform: "matrix(-1 .1 .1 1 210.3 120.9)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M107.3 76.7c0 41.6-30.2 75.3-53.7 75.3C28 152 0 118.3 0 76.7 0 39.7 3 0 53.6 0c50.7 0 53.7 38.8 53.7 76.7",
  transform: "translate(95.1 51.5)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M297 0v297H0V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#H)",
  "data-id-spinner": "true"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M148 296a148 148 0 1 0 0-296 148 148 0 0 0 0 296m0-9a139 139 0 1 1 0-278 139 139 0 0 1 0 278",
  transform: "rotate(-101 148 148)"
}))));
export { SvgCaptureSelfie as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/shared/containers/app/documentCapture/uploadDocuments/pages/IncodeSDKPage/assets/CaptureSelfie.svg", import.meta.url).toString();